import MEmptyState from './MEmptyState.vue';

export { MEmptyState };
export default MEmptyState;
